import api from "@/utils/http";


/**
 功能：
 time: 2026/1/6 18:09
 **/
export function getInvoiceCompanyList(data) {
    return api.post('/admin/invoiceCompany/getList', data)
}

/**
 功能：
 time: 2025/12/25 16:02
 **/
export function saveInvoiceCompany(data) {
    return api.post('/admin/invoiceCompany/eSave', data)
}


/**
 功能：
 time: 2026/1/7 09:50
 **/
export function getInvoiceCompanyDetail(id) {
    return api.post('/admin/invoiceCompany/getDetail', {id })
}

/**
 功能：
 time: 2026/1/7 10:04
 **/
export function deleteInvoiceCompany(id) {
    return api.post('/admin/invoiceCompany/del', {id})
}




